var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:('width: ' + _vm.admin ? '6' : '1.5' + 'em')},[_c('div',{staticClass:"time-area"},[(
				_vm.admin ||
				_vm.index === 0 ||
				_vm.timeslot.time.clone().minutes() === 0 ||
				_vm.hovering ||
				_vm.selected
			)?_c('div',{staticClass:"time-container"},[_c('p',{staticClass:"time-text",class:{ 'time-highlight': _vm.hovering, 'time-selected': _vm.selected }},[_vm._v(" "+_vm._s(_vm.timeslot.time.format('LT'))+" ")])]):_vm._e()]),_vm._l((_vm.appointments),function(s,i){return _c('appointment-cell',{key:i,attrs:{"admin":_vm.admin,"time":_vm.time,"appointmentSlot":s},on:{"selected":function($event){return _vm.$emit('selected', i)},"hover":(h) => (_vm.hovering = h)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }